// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","content":"Header_content__8sQm-","burger":"Header_burger__k5ipm"};